import CommonViewComponent from './CommonViewComponent';

export default class Component extends CommonViewComponent {
    constructor(helper, $container) {
        this.$container = $container || $.create('div');
        this.$container.on('dispose', () => {
            this.destroy();
        });
        this.helper = helper;
        this.elements = [];
    }

    /**
     * Invoked on both server and browser (except the first time for the browser)
     */
    firstRender(data) {
    }

    /**
     * Invoked once on the browser
     *
     * Register events here
     */
    prepare() {

    }

    /**
     * Invoked once on the browser
     */
    destroy() {

    }
}
